import React from 'react'
import classnames from 'classnames'

import useStyles from './styles'
import { useTranslation } from 'react-i18next'

interface ErrorMessageProps {
  error?: string | string[]
  className?: string
  fontSize?: string | number
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ error, className, fontSize }) => {
  // @ts-ignore of useStyles props
  const classes = useStyles({ fontSize })
  const { t } = useTranslation()

  // Don't remove static class 'error', we use it to select all errorMessages in DOM
  // We may need to scroll to ErrorMessage when it's not in the viewport.
  return <div className={classnames(className, 'error', classes.error)}>{t(error || '')}</div>
}

export default ErrorMessage
